import { render } from "./ReportConsignmentIndex.vue?vue&type=template&id=4f31b12b&scoped=true"
import script from "./ReportConsignmentIndex.vue?vue&type=script&lang=js"
export * from "./ReportConsignmentIndex.vue?vue&type=script&lang=js"

import "./ReportConsignmentIndex.vue?vue&type=style&index=0&id=4f31b12b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f31b12b"]])

export default __exports__